export const DEFAULT_VERTICAL = 'default-vertical';
export const DEFAULT_HORIZONTAL = 'default-horizontal';
export const DEFAULT_SIZING = 'default-sizing';

export const VERTICAL = 'vertical';
export const HORIZONTAL = 'horizontal';

export const ALIGN_TOP = 'top';
export const ALIGN_BOTTOM = 'bottom';
export const ALIGN_LEFT = 'left';
export const ALIGN_CENTER = 'center';
export const ALIGN_RIGHT = 'right';

export const ALIGN_LEFT_OR_RIGHT = 'left-or-right';
export const ALIGN_TOP_OR_BOTTOM = 'top-or-bottom';

export const MATCH_SIDE = 'matchSize';

export const CONSTRAIN_WIDTH = 'constrain-width';
export const CONSTRAIN_HEIGHT = 'constrain-height';
export const CONSTRAIN_BOTH = 'constrain-both';

export const ARROW_HEIGHT = 15;
export const ARROW_OFFSET = 23;

export const OPEN = 'open';
export const CLOSED = 'closed';
